/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { Tooltip } from "antd";
import React from "react";
import bookingDownload from "../../assests/images/bookingDownload.svg";
import eyeIcon from "../../assests/images/eyeIcon.svg";
import printerIcon from "../../assests/images/printerIcon.svg";
import uploadIcon from "../../assests/images/uploadIcon.svg";
import editIcon from "../../assests/images/edit-logo.svg";

import "./BookingTable.scss";

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export const column = (
  MyComponent,
  statusFun,
  handleEdit,
  handleEditView,
  handleUpload,
  handleEyeButton
) => [
  {
    title: "AWB Number",
    dataIndex: "awbNumber",
    key: "awbNumber",
    className: "awbNumber",
    defaultSortOrder: "descend",
    render: (text, b) => <a onClick={() => handleEyeButton(b)}>{text} </a>,
  },
  {
    title: "Date",
    dataIndex: "bookingTime",
    key: "bookingTime",
    render: (text, b) => MyComponent(text),
  },

  {
    title: "Booking Type",
    dataIndex: "bookingType",
    key: "bookingType",
  },
  {
    title: "Service Type",
    dataIndex: "serviceType",
    key: "serviceType",
    render: (text) => capitalizeFirstLetter(text),
  },
  {
    title: "Mode",
    dataIndex: "travelBy",
    key: "travelBy",
    width: 150,
    render: (text, val) => capitalizeFirstLetter(text),
  },

  {
    title: "Status",
    dataIndex: "bookingStatus",
    key: "bookingStatus",
    width: 180,
    render: (text) => statusFun(text),
  },

  {
    title: "Action",
    align: "center",

    render: (a, b) => (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          columnGap: "5px",
          cursor: "pointer",
        }}
      >
        <Tooltip title="Edit">
          <p onClick={() => handleEditView(b)} className="vbooking-icons">
            <img src={editIcon} style={{ width: "33px" }} />
          </p>
        </Tooltip>
        <Tooltip title="Upload">
          <p onClick={() => handleUpload(a)} className="vbooking-icons">
            <img src={bookingDownload} style={{ width: "33px" }} />
          </p>
        </Tooltip>
        {/* <Tooltip title="Download">
          <p className="vbooking-icons">
            <img
              src={uploadIcon}
              style={{ width: "33px", cursor: "not-allowed" }}
            />
          </p>
        </Tooltip>
        <Tooltip title="Summary">
          <p onClick={() => handleEyeButton(b)} className="vbooking-icons">
            <img src={eyeIcon} style={{ width: "33px" }} />
          </p>
        </Tooltip>
        <Tooltip title="Print">
          <p className="vbooking-icons">
            <img
              src={printerIcon}
              style={{ width: "30.5px", cursor: "not-allowed" }}
            />
          </p>
        </Tooltip> */}
      </div>
    ),
  },
];
